import React, { useEffect, useState } from 'react'
import {Spinner} from 'react-bootstrap'
import {
  Col,
  FormGroup,
  Form,
  FormText,
  CardBody,
  Row,
  Button,
  Card,
  CardHeader,
  Input
} from "reactstrap";

import WModalGeneric from "../../components/molecules/WModalGeneric";
import { api } from '../../utils/index'
import {BASE_URL} from "../../utils";
import { ToastContainer } from 'react-toastify'
import { notify } from '../../utils/notify'
import { TextareaAutosize } from '@material-ui/core'


const ContentGenForm = () => {
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [acceptedCharCheck, setAcceptedCharCheck] = useState(false)
  const [acceptedGptCheck, setAcceptedGptCheck] = useState(false)

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [client, setClient] = useState("")
  const [site, setSite] = useState("")
  const [sector, setSector] = useState("")
  const [coreServices, setCoreServices] = useState("")
  const [prompt, setPrompt] = useState("")
  const [contentType, setContentType] = useState("Testo di categoria")

  const showPromptPreview = (e) => {
    e.preventDefault()

    let generatedPrompt = ""

    if (contentType === "Testo di categoria") {
      generatedPrompt =
`Sei un SEO Copywriter con anni di esperienza. Scrivi un testo ottimizzato in ottica SEO da inserire in una pagina di listing 
prodotti per la categoria {categoria}. Il sito su cui sarà inserito è ${site || 'NON DISPONIBILE'}, 
un brand del settore ${sector || 'NON DISPONIBILE'} che si occupa di ${coreServices || 'NON DISPONIBILE'}.

Il testo dev'essere sulle 300 parole, con un sottotitolo che richiama le principali parole chiave di ricerca correlate ai prodotti. 
Includi in modo naturale e scorrevole anche le principali keyword relative, come {lista_kw}.
Evidenzia le keyword principali, ma evita il keyword stuffing e ripetizioni troppo forzate e meccaniche.
Utilizza un tono di voce colloquiale ma professionale, per ingaggiare l'utente e dare la possibilità di esplorare la gamma di prodotti e 
servizi offerti dalla pagina. Assicurati di includere anche sinonimi e termini correlati per ampliare il più possibile la semantica. 
Dev'essere un testo che spieghi quali sono i prodotti principali in pagina la loro utilità, informazioni correlate utili, ai fini 
di posizionamento organico e per fornire all'utente una panoramica più completa sul contenuto della pagina.

{info_aggiuntive}

Per permetterti di avere contesto e capire quali sono i contenuti che si posizionano meglio durante le ricerche ti darò in input 
un riassunto delle prime 5 posizioni di Google per le seguenti ricerche.

{riassunti_serp}
`
    } else {
      generatedPrompt =
`Immagina di essere un copywriter professionista con oltre 10 anni di esperienza. Scrivi un articolo su un argomento relativo a {titolo_articolo}. 
L'articolo deve mantenere un tono accessibile, informativo e coinvolgente, pur rimanendo imparziale ed equilibrato. 
Struttura l'articolo con un'introduzione, un corpo e una conclusione. Garantisci leggibilità utilizzando un linguaggio chiaro e, quando necessario, conciso. 
Utilizza transizioni e indicazioni per guidare il lettore attraverso l'articolo.
L’abstract da seguire per la stesura dell’articolo è il seguente: 
{info_aggiuntive}

Per permetterti di avere contesto e capire quali sono i contenuti che si posizionano meglio durante le ricerche ti darò in input 
un riassunto delle prime 5 posizioni di Google per le seguenti ricerche.

{riassunti_serp}
`
    }


    setPrompt(generatedPrompt)
    setShowConfirmModal(true)
  }

  const confirmAndSubmit = () => {
    // e.preventDefault()
    setShowConfirmModal(false)
    handleSubmit()
  }

  const handleSubmit = event => {
    if (event)
      event.preventDefault()

    let formData = new FormData()
    formData.append('customPrompt', prompt)
    formData.append('file', file)
    formData.append('contentType', contentType)
    formData.append('client', client)

    if (file == null) {
      notify(
        'File mancante',
        'error',
      )
      return
    }
    setLoading(true)
    api
      .post('content-gen/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (typeof response.data !== 'undefined') {
          notify(
            'Richiesta mandata. Riceverai una mail al termine dell\'elaborazione',
            'success',
          )
        } else {
          notify(
            'Richiesta fallita. Qualcosa è andato storto, riprovare o contattare un Innovation',
            'error',
          )
        }
        setLoading(false)
        setFile(null)
      })
      .catch(err => {
        if (err?.response?.data) {
          if (err.response.data?.message) {
            notify(
              err.response.data,
              'error'
            )
            console.log(err.response.data)
            setLoading(false)
            setFile(null)
            setAcceptedCharCheck(false)
            setAcceptedGptCheck(false)
          }
        } else {
          setLoading(false)
          setFile(null)
          setAcceptedCharCheck(false)
          setAcceptedGptCheck(false)
        }
      })
  }

  useEffect(() => {
    if (acceptedCharCheck) {
      handleSubmit()
    }
  }, [acceptedCharCheck])

  useEffect(() => {
    if (acceptedGptCheck) {
      handleSubmit()
    }
  }, [acceptedGptCheck])

  return (
    <>
      <WModalGeneric
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onSubmit={confirmAndSubmit}
        body={
          <TextareaAutosize
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            style={{ width: '100%' }}
            minRows={10}
          />
        }
      />

      <Row>
        <div className="col pb-5">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <h1 className="mb-0">Content Gen</h1>
            </CardHeader>
            <CardBody>
              {loading ? (
                <Spinner animation="grow" />
              ) : (
                <Form id="idea-form" action="">

                  {contentType === "Testo di categoria" && (
                    <>
                      <FormGroup row>
                      <Col md={6}>
                        <label htmlFor="style" className="form-control-label">
                          Cliente
                        </label>
                        <Input
                          className="form-control-alternative"
                          id={'text-client'}
                          type={'text'}
                          style={{ border: '0' }}
                          value={client}
                          placeholder={'Company name'}
                          required
                          onChange={event => {
                            setClient(event.target.value)
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <label htmlFor="site" className="form-control-label">
                          Sito
                        </label>
                        <Input
                          className="form-control-alternative"
                          id={'text-site'}
                          type={'text'}
                          style={{ border: '0' }}
                          value={site}
                          placeholder={'www.company-name.com'}
                          required
                          onChange={event => {
                            setSite(event.target.value)
                          }}
                        />
                      </Col>
                    </FormGroup>
                      <FormGroup row>
                        <Col md={6}>
                          <label htmlFor="style" className="form-control-label">
                            Settore
                          </label>
                          <Input
                            className="form-control-alternative"
                            id={'text-sector'}
                            type={'text'}
                            style={{ border: '0' }}
                            value={sector}
                            placeholder={"es. assicurazioni auto"}
                            required
                            onChange={event => {
                              setSector(event.target.value)
                            }}
                          />
                        </Col>
                        <Col md={6}>
                          <label htmlFor="style" className="form-control-label">
                            Prodotti o servizi offerti
                          </label>
                          <Input
                            className="form-control-alternative"
                            id={'text-core-services'}
                            type={'text'}
                            style={{ border: '0' }}
                            value={coreServices}
                            placeholder={""}
                            required
                            onChange={event => {
                              setCoreServices(event.target.value)
                            }}
                          />
                        </Col>
                      </FormGroup>
                    </>
                  )}
                  <FormGroup row>
                    <Col md={6}>
                      <label htmlFor="file" style={{ display: 'block' }}>
                        File
                      </label>
                      <Input
                        className="form-control-alternative"
                        id={'file'}
                        type={'file'}
                        style={{ border: '0' }}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        required
                        onChange={event => {
                          setFile(event.target.files[0])
                        }}
                      />
                      <FormText color="muted" align={'left'}>
                        Carica un file contenente le tue keywords.{' '}
                        <br />
                        <b>
                          Il file deve contenere le colonne: Titolo articolo/Nome categoria | KW Principale | KW Secondarie | Info Aggiuntive
                        </b>
                      </FormText>
                    </Col>
                    <Col md={6}>
                      <label htmlFor="parafraph" className="form-control-label">
                        Tipologia contenuto
                      </label>
                      <Input
                        className="form-control-alternative"
                        id={'content-type'}
                        type={'select'}
                        style={{ border: '0' }}
                        // value={paragraphsNumber}
                        placeholder={'Definisci la tipologia di contenuto da creare'}
                        required
                        onChange={e => setContentType(e.target.value)}
                      >
                        <option>
                          Testo di categoria
                        </option>
                        <option>
                          Articolo editoriale
                        </option>
                      </Input>
                    </Col>
                  </FormGroup>
                  <Row style={{ display: "flex", justifyContent: "flex-start", paddingLeft: 11 }}>
                    <Button
                      type="button"
                      color="secondary"
                      size="lg"
                      style={{ marginRight: '10px' }}
                      onClick={() => {
                        window.location.href = `${BASE_URL}/api/1/get-content-gen-file/0`;
                      }}
                    >
                      Scarica Template
                    </Button>
                    <Button color="info" size="lg" onClick={showPromptPreview}>Invia</Button>
                  </Row>
                </Form>
              )}
              <ToastContainer />
            </CardBody>
          </Card>
        </div>
      </Row>
    </>
  )

}

export default ContentGenForm
